import { FC } from 'react'
import styled, { css } from 'styled-components'
import useSelectedCategories from '@app.feature/jobCategory/hooks/useSelectedCategories'
import { SelectedItem } from '../../selectedItem'

interface IFSelectedCategoriesProps {
  className?: string
}

const SelectedCategories: FC<IFSelectedCategoriesProps> = ({ className }) => {
  const { selectedCategories } = useSelectedCategories()

  if (selectedCategories.length === 0) {
    return null
  }
  return (
    <StyledWrapper className={className}>
      {selectedCategories.map((category) => (
        <StyledSelectedItem
          key={category.id}
          category={category}
          order={category.order}
        />
      ))}
    </StyledWrapper>
  )
}

export default SelectedCategories

const StyledWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100%;
  height: 50px;
  padding: 15px 20px 0;
`

interface IFStyledSelectedItemProps {
  order: number
}

const StyledSelectedItem = styled(SelectedItem)<IFStyledSelectedItemProps>`
  ${({ order }) => css`
    white-space: nowrap;
    order: -${order};
    margin-right: 5px;
  `}
`
